const countryDisplayNames: Record<string, Intl.DisplayNames> = {};

export const getCountryName = (countryCode: string, language: string = 'en') => {
  if (!countryCode || countryCode.length !== 2) {
    return countryCode || '';
  }

  const normalizedCountryCode = countryCode.toUpperCase();

  let validLanguage = language;
  try {
    new Intl.DisplayNames([language], { type: 'region' });
  } catch {
    validLanguage = 'en';
  }

  if (!countryDisplayNames[validLanguage]) {
    countryDisplayNames[validLanguage] = new Intl.DisplayNames([validLanguage], {
      type: 'region',
    });
  }

  try {
    return countryDisplayNames[validLanguage].of(normalizedCountryCode);
  } catch {
    return normalizedCountryCode;
  }
};
